module.exports = __webpack_public_path__ + "static/media/hotWaterDefault.ae2828d1.png";